import Play from './assets/play.svg';
import Back from './assets/back-arrow.svg';
import Edit from './assets/edit.svg';
import Delete from './assets/delete.svg';
import Save from './assets/save.svg';
import Yes from './assets/yes.svg';
import No from './assets/no.svg';
import Add from './assets/add.svg';
import Settings from './assets/settings.svg';
import Download from './assets/download.svg'
import Minus from './assets/substract.svg';
import Arrow from './assets/arrow.svg';




import Dots from './assets/dots.svg';
import BackArrow from './assets/back-arrow.svg';
import Calories from './assets/calories.svg';
import Checkmark from './assets/checkmark.svg';
import CircleCheckmark from './assets/circle-checkmark.svg';
import Clipboard from './assets/clipboard.svg';
import Close from './assets/close.svg';
import Dumbbell from './assets/dumbbell.svg';
import Exercise from './assets/exercise.svg';
import Filter from './assets/filter.svg';
import Folder from './assets/folder.svg';
import Food from './assets/food.svg';
import Home from './assets/home.svg';
import Lap from './assets/lap.svg';
import Link from './assets/link.svg';
import List from './assets/list.svg';
import Loading from './assets/loading.svg';
import Maximize from './assets/maximise.svg';
import Minimize from './assets/minimise.svg';
import Muscle from './assets/muscle.svg';
import Next from './assets/next.svg';
import Previous from './assets/previous.svg';
import Pause from './assets/pause.svg';
import Plus from './assets/plus.svg';
import PlusCircle from './assets/plus-circle.svg';
import Profile from './assets/profileIcon.svg';
import ProfilePlaceholder from './assets/profile-placeholder.png';
import Restart from './assets/restart.svg';
import Sleep from './assets/sleep.svg';
import Start from './assets/start.svg';
import Steps from './assets/steps.svg';
import Stop from './assets/stop.svg';
import Stopwatch from './assets/stopwatch.svg';
import Substract from './assets/substract.svg';
import Time from './assets/time.svg';
import Water from './assets/water.svg';
import Weight from './assets/weight.svg';
import Workout from './assets/workout.svg';
import Tag from './assets/tag.svg';
import InfoCircle from './assets/infoCircle.svg';
import Search from './assets/search.svg';
import Skip from './assets/skip.svg';
import Circle from './assets/circle.svg';
import Meal from './assets/meal.svg';
import Quantity from './assets/quantity.svg';
import Note from './assets/note.svg';
import Goals from './assets/goals.svg';
import Menu from './assets/menu.svg';
import Hide from './assets/hide.svg';
import EnableFullscreen from './assets/enableFullscreen.svg';
import DisableFullscreen from './assets/disableFullscreen.svg';
import Log from './assets/log.svg';
import Login from './assets/login.svg';
import Logout from './assets/logout.svg';
import Equipment from './assets/equipment.svg';
import Tags from './assets/tags.svg';
import Fields from './assets/inputField.svg';
import Help from './assets/help.svg';
import EnabledAwake from './assets/enabledScreenWake.svg';
import DisabledAwake from './assets/disabledScreenWake.svg';
import Library from './assets/library.svg';
import Activity from './assets/activity.svg';
import Sync from './assets/sync.svg';
import Duplicate from './assets/duplicate.svg';
import NotCompleted from './assets/x.svg';
import Line from './assets/line.svg';
import Completed from './assets/completed.svg';
import ArrowUp from './assets/arrowUp.svg';
import ArrowDown from './assets/arrowDown.svg';
import Sort from './assets/sort.svg';
import Levels from './assets/levels.svg';
import Import from './assets/import.svg';
import Export from './assets/export.svg';
import ItemList from './assets/item-list.svg';
import CardList from './assets/cards.svg';
import ExpandedList from './assets/expanded-list.svg';

export const IconLibrary = {
    Import,
    Export,
    ItemList,
    CardList,
    ExpandedList,
    Sort,
    Levels,
    ArrowUp,
    ArrowDown,
    NotCompleted,
    Line,
    Completed,
    Sync,
    Activity,
    Library,
    ProfilePlaceholder,
    Equipment,
    Fields,
    Tags,
    Help,
    EnabledAwake,
    DisabledAwake,
    Login,
    Logout,
    Log,
    Play,
    InfoCircle,
    Back,
    Edit,
    Delete,
    Save,
    Yes,
    No,
    Add,
    Settings,
    Download,
    Minus,
    Arrow,
    BackArrow,
    Calories,
    Checkmark,
    CircleCheckmark,
    Clipboard,
    Close,
    Dumbbell,
    Exercise,
    Filter,
    Folder,
    Food,
    Home,
    Lap,
    Link,
    List,
    Loading,
    Maximize,
    Minimize,
    Muscle,
    Next,
    Previous,
    Pause,
    Plus,
    PlusCircle,
    Profile,
    Restart,
    Search,
    Sleep,
    Start,
    Steps,
    Stop,
    Stopwatch,
    Substract,
    Time,
    Water,
    Weight,
    Workout,
    Tag,
    Skip,
    Circle,
    Meal,
    Quantity,
    Note,
    Goals,
    Menu,
    Dots,
    Hide,
    EnableFullscreen,
    DisableFullscreen,
    Duplicate
}